<template>
  <div class="million-read-list">
    <div class="million-read-list-header ym-border-bottom">
      <div class="million-read-list-header-home"
           @click="handleToHome"
      >
        <ym-icon name="back" />
      </div>
      <div class="million-read-list-search">
        <div class="million-read-list-search-bar">
          <ym-icon class="icon"
                   name="search"
          />
          <form  action=""
                 @submit.prevent="handleSubmit"
          >
            <input class="input"
                   :placeholder="placeholder ? placeholder : '书名/关键字'"
                   type="search"
                   v-model="keyword"
                   ref="searchInput"
                   @keyup.13="hideKeyBoard"
                   v-focus.lazy="true"
            >
          </form>
          <ym-icon v-if="keyword !== ''"
                   class="search-input-icon icon-close"
                   name="round-close-fill"
                   @click.native="handleCancelSearch"
          />
        </div>
      </div>
    </div>

    <filter-bar type="library"
                show-grade
                :params="params"
                @submit="handleFilterBarSubmit"
                @loaded="handleFilterBarData"
    />

    <div class="million-read-list-container">
      <div class="million-read-list-container-category">
        <div v-for="(item,index) in category.list"
             :key="index"
             class="million-read-list-container-category-item
                    ym-line-ellipsis"
             :class="{ 'active': categoryValue === item.value }"
             @click="handleSelectCategory(item.value)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="million-read-list-container-list">
        <ym-loadmore v-model="loading"
                     :finished="allLoad"
                     @load="fetchData"
        >
          <book-list :list="list"
                     type="extra-small"
          />
        </ym-loadmore>
        <empty-page v-if="list.length === 0"
                    :hint="emptyPageHint"
                    type="million-read"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import { decorator, before } from 'ym-reporter-vue';
  import FilterBar from '@/pages/MillionRead/components/FilterBar';
  import BookList from '@/pages/MillionRead/components/BookList';
  import EmptyPage from '@/components/EmptyPage';
  import { getBookExplore } from '@/services/million-read';
  import { LIMIT } from '@/utils/constant';
  import { getQuery, handleRedirectAPPPage, isAppWebView } from '@/utils';

  export default {
    name: 'MillionReadList',
    metaInfo: {},
    components: {
      'ym-loadmore': Loadmore,
      FilterBar,
      BookList,
      EmptyPage,
    },
    data() {
      return {
        list: [],
        start: 0,
        loading: false,
        allLoad: false,

        query: null,
        params: '',
        keyword: '',
        placeholder: '',
        filterResult: {},
        gradeResult: [],
        category: {},
        categoryValue: '',
      };
    },
    computed: {
      emptyPageHint() {
        return this.allLoad ? '没有相关书籍哦~' : '正在加载~';
      },
    },
    methods: {
      handleToHome() {
        const inAppWebView = isAppWebView();
        if (inAppWebView) {
          handleRedirectAPPPage('youthmba://million/read?type=selectHome?dismiss=1');
          return;
        }
        this.$router.push({ name: 'MillionReadSelect' });
      },
      async fetchData() {
        if (this.allLoad) return;
        const params = Object.assign({
          start: this.start,
          limit: LIMIT,
          gradeList: this.gradeResult,
          keyword: this.keyword,
        }, this.query, this.filterResult);

        this.loading = true;
        const data = await getBookExplore(params);
        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.list = [...this.list, ...data.list];
        this.start = data.start;
        this.loading = false;
      },
      handleCancelSearch() {
        this.keyword = '';
      },
      @decorator(before(function () {
        this.$reporter.report('MILLION_VIP_SEARCH_CONFIRM_CLICK', {
          q: this.keyword,
        });
      }))
      hideKeyBoard() {
        this.$refs.searchInput.blur();
      },
      initData() {
        this.list = [];
        this.start = 0;
        this.allLoad = false;
      },
      @decorator(before(function (params) {
        this.$reporter.report('MILLION_VIP_LIBRARY_FILTER_CLICK', {
          params,
          type: 'library',
        });
      }))
      handleFilterBarSubmit(params) {
        this.initData();
        this.filterResult = params;
        this.fetchData();
      },
      handleFilterBarData(data) {
        this.placeholder = data.keyword || '';
        this.category = data.category || [];
        if (this.query.category) this.categoryValue = this.query.category;
      },
      @decorator(before(function (value) {
        this.$reporter.report('MILLION_VIP_LIBRARY_FILTER_CLICK', {
          category: value,
          type: 'library',
        });
      }))
      handleSelectCategory(value) {
        this.categoryValue = value;
        this.initData();
        this.filterResult[this.category.key] = value;
        this.fetchData();
      },
      handleSubmit() {
        if (!this.keyword) this.keyword = this.placeholder;
        this.initData();
        this.fetchData();
      },
      sliceParams(params) {
        const index = decodeURI(params).indexOf('?');
        if (index === -1) return '';
        return decodeURI(params).slice(decodeURI(params).indexOf('?') + 1);
      },
    },
    created() {
      this.query = getQuery(this.$route.query);
      this.params = this.sliceParams(this.$route.fullPath);
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-list {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: @color-white;

    &-header {
      box-sizing: border-box;
      padding: 0 @size-base;
      display: flex;
      align-items: center;
      &-home {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        color: @color-text-base;
        font-size: @font-size-medium;
      }
    }
    &-search {
      box-sizing: border-box;
      width: 100%;
      height: 88px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &-search-bar {
      box-sizing: border-box;
      flex: 1;
      height: 64px;
      padding-left: @size-base;
      display: flex;
      align-items: center;
      background: #f5f5fa;
      border-radius: 20px;

      .icon {
        color: #a1a1b3;
        font-size: @font-size-base;
      }
      .input {
        width: 520px;
        height: 64px;
        color: #a1a1b3;
        font-size: 26px;
        background: none;
        padding-left: 6px;
        border: none;
        resize: none;
        outline-offset: 0;
        overflow: hidden;
        outline: none;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
      }
      &-cancel-btn {
        margin-left: @size-base;
        word-break: keep-all;
      }
    }

    &-container {
      flex: 1;
      display: flex;
      overflow-y: scroll;
      &-category {
        width: 180px;
        background: #f5f6fa;
        height: 100%;
        overflow-y: scroll;
        &-item {
          position: relative;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: @color-text-light;
          font-size: @font-size-base;
          &.active {
            color: @color-text-base;
            background: @color-white;
            font-weight: @font-weight-bold;
            &:before {
              position: absolute;
              content: '';
              width: 8px;
              height: 40px;
              background: #fed100;
              left: 0;
              top: 50%;
              margin-top: -20px;
            }
          }
        }
      }
      &-list {
        flex: 1;
        height: 100%;
        overflow-y: scroll;
      }
    }
  }

</style>
